"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _HBNewTable = require("./HBNewTable.styles");
var _HBNewTableCellList = _interopRequireDefault(require("./HBNewTableCellList"));
var _HBNewTableSpacer = _interopRequireDefault(require("./HBNewTableSpacer"));
var _HBNewTableExpandedRow = _interopRequireDefault(require("./HBNewTableExpandedRow"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBNewTableRow = function HBNewTableRow(_ref) {
  var item = _ref.item,
    columnDefinitions = _ref.columnDefinitions,
    itemId = _ref.itemId,
    isSelectableMode = _ref.isSelectableMode,
    expandableProps = _ref.expandableProps,
    hasSpacer = _ref.hasSpacer,
    isSelectable = _ref.isSelectable,
    isRowHovered = _ref.isRowHovered,
    setHoveredRowItemId = _ref.setHoveredRowItemId;
  var _useState = (0, _react.useState)(undefined),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isRowExpanded = _useState2[0],
    setIsRowExpanded = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isRowExpanded !== undefined) {
      var _expandableProps$onEx;
      expandableProps === null || expandableProps === void 0 || (_expandableProps$onEx = expandableProps.onExpand) === null || _expandableProps$onEx === void 0 || _expandableProps$onEx.call(expandableProps, isRowExpanded, item);
    }
  }, [expandableProps, isRowExpanded, item]);
  var expandOnClickProps = expandableProps !== null && expandableProps !== void 0 && expandableProps.expandOnRowClick ? {
    tabIndex: 0,
    onClick: function onClick() {
      if (!isSelectableMode) {
        setIsRowExpanded(function (prev) {
          return !prev;
        });
      }
    },
    onKeyPress: function onKeyPress(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (!isSelectableMode) {
          setIsRowExpanded(function (prev) {
            return !prev;
          });
        }
      }
    }
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasSpacer && /*#__PURE__*/_react["default"].createElement(_HBNewTableSpacer["default"], {
    colSpan: columnDefinitions.length,
    height: 12
  }), !hasSpacer && expandableProps && /*#__PURE__*/_react["default"].createElement(_HBNewTableSpacer["default"], {
    colSpan: columnDefinitions.length,
    height: 4
  }), /*#__PURE__*/_react["default"].createElement(_HBNewTable.NewTableStyledTrRow, (0, _extends2["default"])({
    className: "actual-row",
    onMouseEnter: function onMouseEnter() {
      return setHoveredRowItemId(itemId);
    },
    onMouseLeave: function onMouseLeave() {
      return setHoveredRowItemId(null);
    },
    expandOnRowClick: expandableProps === null || expandableProps === void 0 ? void 0 : expandableProps.expandOnRowClick,
    hasSpacer: hasSpacer,
    isRowExpanded: isRowExpanded,
    $isSelectable: isSelectable
  }, expandOnClickProps), /*#__PURE__*/_react["default"].createElement(_HBNewTableCellList["default"], {
    columnDefinitions: columnDefinitions,
    item: item,
    isRowHovered: isRowHovered,
    itemId: itemId,
    isRowExpanded: isRowExpanded,
    setIsRowExpanded: setIsRowExpanded
  })), (expandableProps === null || expandableProps === void 0 ? void 0 : expandableProps.renderComponent) && /*#__PURE__*/_react["default"].createElement(_HBNewTableExpandedRow["default"], {
    colSpan: columnDefinitions.length,
    renderComponent: expandableProps.renderComponent,
    isRowExpanded: isRowExpanded,
    item: item
  }));
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HBNewTableRow);
//# sourceMappingURL=HBNewTableRow.js.map